import React, { useState } from "react";
import "./styles/BhpCategoriesSelection.css";
import {
  BhpThemeHeaderWithBack,
  BusinessDetailsType,
  BusinessProductCategoryWithProducts,
} from "../pages/BussinessHomePage";
import {
  IonButton,
  IonCol,
  IonFooter,
  IonGrid,
  IonItem,
  IonLabel,
  IonPopover,
  IonRow,
  IonSearchbar,
} from "@ionic/react";
import ContentWithBackground from "../UI/ContentWithBackground";
import BhpCategoryCard from "./BhpCategoryCard";
import { searchStringSuccess } from "../common/commonFunctions";
import { AdvanceCustomizationType } from "../types/data_types";

/*******************************************************************
 * Name : BhpCategoriesSelection
 * Description : This component is used to display the category
 *                cards.
 ********************************************************************/
const BhpCategoriesSelection: React.FC<{
  open: boolean;
  dismiss: () => void;
  bussinessDetailsDB: BusinessDetailsType;
  prodCategories: BusinessProductCategoryWithProducts[];
  categoryCardClick: (category: string) => void;
  advanceCustomization: AdvanceCustomizationType;
}> = (props) => {
  const [catSearch, setCatSearch] = useState("");
  return (
    <IonPopover
      // enterAnimation={enterAnimation}
      isOpen={props.open}
      onDidDismiss={() => {
        props.dismiss();
        setCatSearch("");
      }}
      className="bhp-cat-sel-modal"
    >
      <BhpThemeHeaderWithBack
        onBack={props.dismiss}
        title={
          props.bussinessDetailsDB.isMarket
            ? props.bussinessDetailsDB.marketType === "MARKET"
              ? "Shop Categories"
              : props.bussinessDetailsDB.marketType === "VYPZEE"
              ? "Explore Markets"
              : "Society Professionals"
            : "Product Categories"
        }
      ></BhpThemeHeaderWithBack>
      <ContentWithBackground>
        <div
          style={{
            position: "sticky",
            zIndex: "1000",
            top: 0,
            background: "white",
          }}
        >
          <IonItem>
            <IonSearchbar
              value={catSearch}
              onIonChange={(e) => {
                setCatSearch(e.detail.value);
              }}
            />
          </IonItem>
        </div>
        {!props.prodCategories.length && (
          <IonItem>
            <IonLabel color={"secondary"}>No Categories!</IonLabel>
          </IonItem>
        )}
        {props.bussinessDetailsDB.isMarket && (
          <IonGrid>
            <IonRow>
              {props.prodCategories
                .filter((el) => searchStringSuccess(catSearch, el.category))
                .map((item, idx) => {
                  return (
                    <IonCol size="4" key={idx}>
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          justifyContent: "center",
                        }}
                      >
                        <BhpCategoryCard
                          catNum={
                            item.numProducts
                              ? item.numProducts
                              : item.products.length
                          }
                          listMode={!props.bussinessDetailsDB.isMarket}
                          imgFile={item?.catImgObj?.fileName}
                          name={item.category}
                          // horizontalMode={true}
                          subText={`${
                            item.numProducts
                              ? item.numProducts
                              : item.products.length
                          } Shops`}
                          onClick={props.categoryCardClick.bind(
                            this,
                            item.category
                          )}
                          advanceCustomization={props.advanceCustomization}
                        />
                      </div>
                    </IonCol>
                  );
                })}
            </IonRow>
          </IonGrid>
        )}
        {!props.bussinessDetailsDB.isMarket &&
          props.prodCategories
            .filter((el) => searchStringSuccess(catSearch, el.category))
            .map((item, idx) => {
              return (
                <BhpCategoryCard
                  key={idx}
                  catNum={item.products.length}
                  listMode={!props.bussinessDetailsDB.isMarket}
                  imgFile={item.catImgObj?.fileName}
                  name={item.category}
                  // horizontalMode={true}
                  subText={`${item.products.length} Shops`}
                  onClick={props.categoryCardClick.bind(this, item.category)}
                  advanceCustomization={props.advanceCustomization}
                />
              );
            })}
      </ContentWithBackground>
      <IonFooter>
        <div style={{ padding: "5px" }}>
          <IonButton expand="block" color={"danger"} onClick={props.dismiss}>
            Close
          </IonButton>
        </div>
      </IonFooter>
    </IonPopover>
  );
};

export default BhpCategoriesSelection;
